import { SupportedLocale } from 'i18n/constants';

import enUSMessages from './en-US';
import frBEMessages from './fr-BE';
import nlNLMessages from './nl-NL';
import ptPTMessages from './pt-PT';
import esESMessages from './es-ES';
import deDEMessages from './de-DE';
import fiFIMessages from './fi-FI';

export const i18n: Record<SupportedLocale, Record<string, string>> = {
  'en-US': enUSMessages,
  'es-ES': esESMessages,
  'de-DE': deDEMessages,
  'fr-BE': frBEMessages,
  'fi-FI': fiFIMessages,
  'nl-NL': nlNLMessages,
  'pt-PT': ptPTMessages,
};
